const normalizeCompanyCode = (rawValue) => {
  return String(rawValue || '')
    .trim()
    .toLowerCase()
    .replace(/ğ/g, 'g')
    .replace(/ü/g, 'u')
    .replace(/ş/g, 's')
    .replace(/ı/g, 'i')
    .replace(/ö/g, 'o')
    .replace(/ç/g, 'c')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
};

const PLATFORM_COMPANY_CODE = 'platform';

const isPlatformCompanyCode = (company) => normalizeCompanyCode(company) === PLATFORM_COMPANY_CODE;

const clearTenantAuthStorage = () => {
  localStorage.removeItem('jansoft-token');
  localStorage.removeItem('user');
  localStorage.removeItem('tenant-code');
  sessionStorage.removeItem('jansoft-token');
  sessionStorage.removeItem('user');
  sessionStorage.removeItem('tenant-code');
};

const clearRememberedPlatformCredentials = () => {
  try {
    const rememberedRaw = localStorage.getItem('login-remember');
    if (!rememberedRaw) return;
    const remembered = JSON.parse(rememberedRaw);
    if (isPlatformCompanyCode(remembered?.company)) {
      localStorage.removeItem('login-remember');
    }
  } catch (_error) {
    localStorage.removeItem('login-remember');
  }
};

export {
  PLATFORM_COMPANY_CODE,
  normalizeCompanyCode,
  isPlatformCompanyCode,
  clearTenantAuthStorage,
  clearRememberedPlatformCredentials
};
